import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { PrivateNavbarComponent } from './navbar/navbar';
import { PublicFooterComponent } from '@/app/layouts/public-layout/footer/footer';
import { LanguageFacade } from '@/app/core/language/facades/language.facade';
import { ToastService } from '@/app/core/services/toast/toast.service';
import { AlertComponent } from '@/app/features/basic-components/alert/alert';
import { QuotationProgressToastComponent } from '@/app/features/general-components/toasts/quotation-progress-toast/quotation-progress-toast';
import { ProfileCompletionModalComponent } from '@/app/features/general-components/modals/profile-completion-modal/profile-completion-modal';
import { CheckoutProfileGateService } from '@/app/features/pages/private/checkout/services/checkout-profile-gate.service';

@Component({
  selector: 'app-private-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, PrivateNavbarComponent, PublicFooterComponent, AlertComponent, QuotationProgressToastComponent, ProfileCompletionModalComponent],
  templateUrl: './private-layout.html',
  styleUrl: './private-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateLayoutComponent {
  // Inicializa el LanguageFacade para que configure ngx-translate al cargar el layout
  private readonly languageFacade = inject(LanguageFacade);
  readonly toastService = inject(ToastService);
  readonly profileGate = inject(CheckoutProfileGateService);
}
